import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import introAnimation from "../img/intro.json";

const Login = ({ nickname, setNickname, setIsAuthenticated }) => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [showIntro, setShowIntro] = useState(false);
  const [userType, setUserType] = useState("student");

  const handleLogin = async () => {
    if (nickname.trim() === "") {
      alert("닉네임을 입력해주세요.");
      return;
    }

    if (password.length !== 4 || !/^\d+$/.test(password)) {
      alert("비밀번호는 4자리 숫자여야 합니다.");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_CHAT_SERVER_URL}/member/sign-in`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: nickname,
            password: password,
            role: userType, // 'student' 또는 'parent'
          }),
        }
      );

      if (response.ok) {
        const data = await response.json();
        // UUID 저장
        localStorage.setItem("userUuid", data.uuid);
        setIsAuthenticated(true);
        setShowIntro(true);
        setTimeout(() => {
          setShowIntro(false);
          navigate("/chat");
        }, 2000);
      } else {
        const errorData = await response.json();
        alert(
          errorData.message ||
            "로그인에 실패했습니다. 닉네임과 비밀번호를 확인해주세요."
        );
      }
    } catch (error) {
      console.error("로그인 에러:", error);
      alert("로그인 중 오류가 발생했습니다.");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white">
      {showIntro ? (
        <div className="flex-1 flex items-center justify-center">
          <Lottie
            animationData={introAnimation}
            style={{ width: 150 }}
            loop={true}
          />
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center gap-4 p-8 rounded-lg">
          <h1 className="text-2xl font-bold mb-4">Book Agent</h1>
          <div className="flex gap-4 mb-2">
            <label className="flex items-center">
              <input
                type="radio"
                name="userType"
                value="student"
                checked={userType === "student"}
                onChange={(e) => setUserType(e.target.value)}
                className="mr-2"
              />
              학생
            </label>
            <label className="flex items-center">
              <input
                type="radio"
                name="userType"
                value="parent"
                checked={userType === "parent"}
                onChange={(e) => setUserType(e.target.value)}
                className="mr-2"
              />
              학부모
            </label>
          </div>
          <input
            type="text"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
            placeholder="닉네임을 입력하세요"
            className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && handleLogin()}
            placeholder="비밀번호를 입력하세요"
            className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <button
            onClick={handleLogin}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 w-full"
          >
            로그인
          </button>
          <button
            onClick={() => navigate("/register")}
            className="text-gray-500 hover:text-gray-700 underline text-sm"
          >
            회원가입
          </button>
        </div>
      )}
    </div>
  );
};

export default Login;
